var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":'tinymce_' + _vm.editorId}})
}
var staticRenderFns = []

export { render, staticRenderFns }